(function () {
  'use strict';

  const shortListComponent = document.querySelectorAll('.event-shortlist');
  const iCalComponent = document.querySelectorAll('#eventMeta');

  shortListComponent.forEach((component) => {
    const saveButton = component.querySelector('.event-shortlist__button');
    const eventId = saveButton.dataset.id;

    //uses dynamic key if is available or else use default key
    const key = window.searchModuleProps && window.searchModuleProps.localStorageKey ? window.searchModuleProps.localStorageKey : 'default-key';
    let eventListStorage = JSON.parse(localStorage.getItem(key)) || [];

    //check if event is already saved
    const isSaved = isEventSaved(eventId, eventListStorage);
    updateButtonState(saveButton, isSaved);

    saveButton.addEventListener('click', () => {
      if (!eventListStorage) {
        eventListStorage = [];
      }

      const eventDate = {
        id: saveButton.dataset.id,
        imageUrl: saveButton.dataset.imageurl,
        alt: saveButton.dataset.alt,
        heading: saveButton.dataset.heading,
        url: saveButton.dataset.url,
        datetime: saveButton.dataset.datetime,
        location: saveButton.dataset.location,
        startDate: saveButton.dataset.startdate,
        endDate: saveButton.dataset.enddate,
        //extra dataset for peer support
        summary: saveButton.dataset.summary,
        openDate: saveButton.dataset.opendate,
        timeHeading: saveButton.dataset.timeheading
      };

      let isSaved = isEventSaved(eventId, eventListStorage);

      if (isSaved) {
        //remove the event from storage
        const indexToRemove = eventListStorage.findIndex((event) => event.id === eventId);
        if (indexToRemove !== -1) {
          eventListStorage.splice(indexToRemove, 1);
        }
      } else {
        //add event to storage
        eventListStorage.push(eventDate);
      }

      //update local storage
      localStorage.setItem(key, JSON.stringify(eventListStorage));

      //toggle button state
      updateButtonState(saveButton, !isSaved);

      //diplay success message
      const successMessage = component.querySelector('.event-shortlist__text--success');
      successMessage.classList.toggle('hide', isSaved);
    });
  });

  // function to check if an Event ID is in localStorage
  function isEventSaved(eventId, eventListStorage) {
    return eventListStorage.findIndex((event) => event.id === eventId) !== -1;
  }

  //function to update the button state based on storage
  function updateButtonState(saveButton, isSaved) {
    const addButtonText = saveButton.querySelector('.event-shortlist__button-text--add');
    const removeButtonText = saveButton.querySelector('.event-shortlist__button-text--remove');

    addButtonText.classList.toggle('hide', isSaved);
    removeButtonText.classList.toggle('hide', !isSaved);

    // Update aria-pressed attribute
    saveButton.setAttribute('aria-pressed', isSaved);
  }

  iCalComponent.forEach((component) => {
    const calendarSection = component.querySelector('#metaCalendar');
    const eventInfo = document.querySelectorAll('meta[name^="event"]');
    const eventMetaObject = {};

    eventInfo.forEach((meta) => {
      const name = meta.getAttribute('name');
      const content = meta.getAttribute('content');
      eventMetaObject[name] = content;
    });

    //create .ics file
    const icsContent = generateICS(eventMetaObject);

    //create a download link
    const calendarLink = document.createElement('a');
    calendarLink.className = 'event-meta__link';
    calendarLink.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(icsContent);
    calendarLink.download = 'event.ics';
    calendarLink.textContent = 'Add to calendar';

    //adddownload link to DOm
    calendarSection.appendChild(calendarLink);
  });

  // Function to format date to iCalendar format
  function formatDate(date) {
    return date.toISOString().replace(/-|:|\.\d+/g, '');
  }

  // generate .ics file content
  function generateICS(event) {
    const formattedStartDate = formatDate(new Date(event.eventStartDate));
    const formattedEndDate = formatDate(new Date(event.eventEndDate));

    return `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${event['eventSummary']}
UID:${event['eventUid']}
DTSTART:${formattedStartDate}
DTEND:${formattedEndDate}
LOCATION:${event['eventLocation']}
DESCRIPTION:${event['eventDescription']}
END:VEVENT
END:VCALENDAR`;
  }
})();
